import regular from './RTLUnitedText-Regular.woff';
import bold from './RTLUnitedText-Bold.woff';
import { FONT_WEIGHT, OPEN_TYPE_WEIGHT } from '../../constants';
import { makeFontDescriptor } from '../../utils';

export const fontFamily = 'Source Sans Pro';

export const fontWeightMap = {
  [FONT_WEIGHT.ID_1]: OPEN_TYPE_WEIGHT.REGULAR,
  [FONT_WEIGHT.ID_2]: OPEN_TYPE_WEIGHT.REGULAR,
  [FONT_WEIGHT.ID_3]: OPEN_TYPE_WEIGHT.BOLD,
  [FONT_WEIGHT.ID_4]: OPEN_TYPE_WEIGHT.BOLD,
};

const makeCurrentFontDescriptor = (url, weight) => makeFontDescriptor(fontFamily, url, weight);

export const descriptors = [
  makeCurrentFontDescriptor(regular, fontWeightMap[FONT_WEIGHT.ID_1]),
  makeCurrentFontDescriptor(regular, fontWeightMap[FONT_WEIGHT.ID_2]),
  makeCurrentFontDescriptor(bold, fontWeightMap[FONT_WEIGHT.ID_3]),
];
